import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updatePaymentMode } from "../features/calendarWidgetSlice";

const PaymentMode = () => {
  const dispatch = useDispatch();
  const [checkedStatus, setCheckedStatus] = useState("online");

  const handleChange = (e) => {
    dispatch(updatePaymentMode({ paymentMode: e.target.value }));
    setCheckedStatus(e.target.value);
  };

  return (
    <div>
      <fieldset
        style={{
          // marginTop: "100px"
          // backgroundColor: "#eee",
          border: "none",
          padding: "20px 0px",
          borderRadius: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "80vw",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="radio"
            name="consultation-type-radio"
            id="cash"
            value="cash"
            style={{
              accentColor: "var(--green)",
              height: "24px",
              width: "24px",
              marginRight: "8px",
            }}
            onChange={handleChange}
            checked={checkedStatus === "cash"}
          />
          <label htmlFor="cash">Cash</label>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="radio"
            name="consultation-type-radio"
            id="online"
            value="online"
            onChange={handleChange}
            style={{
              accentColor: "var(--green)",
              height: "24px",
              width: "24px",
              marginRight: "8px",
              border: "none",
            }}
            checked={checkedStatus === "online"}
          />
          <label htmlFor="online">Online</label>
        </div>
      </fieldset>
    </div>
  );
};

export default PaymentMode;
